import strFunc from "@/lib/lyg/string";
import Style from "../../css/style.module.css";
import ColorFunc from "@/pcomponents/common/content/todo/color/func/color_func";
import TodoInfoArrFunc from "@/pcomponents/common/content/todo/list/info_arr_func";
import MidTodoArea from "@/pages/comp/plan/todo/stu_card_list/area/card_list/area/card_list/card_box/mid_todo";

function TdTodoSumArea(props: any) {
  let myProps = {
    todo_info_arr: [],
    openTodoDaySort: (inData: any) => { },
    select_stu_name: "",
    select_stu_seq: "",
    select_date: "",
    ...props
  };

  let td_sort_data_json = TodoInfoArrFunc.get_td_sot_data_arr({
    info: {
      todo_arr: myProps.todo_info_arr
    },
    base_date_str: myProps.select_date,
    pre_date_str: myProps.select_date,
  });
  let td_sort_data_arr: any = [];
  for (let key in td_sort_data_json) {
    if (key != "pre_homework") {
      td_sort_data_arr.push(td_sort_data_json[key]);
    }
  }

  const get_todo_detail_tags = (row_todo_info_arr: []) => {
    let todo_detail_tags = row_todo_info_arr.map((todo_info: any, idx: number) => {
      let color_style_json = ColorFunc.get_color_style_of_percent(todo_info.percent);
      let title_str = todo_info.a_title;
      if (todo_info.file_arr && todo_info.file_arr.length > 0) {
        title_str = title_str + " (" + todo_info.file_arr.length + ")";
      }
      return (
        <div key={idx} className={Style.todo_sum_con_wrap} style={{ background: "#fff" }}>
          <span>
            <input type="text" value={title_str} readOnly style={{ border: 0, width: "75%" }} />
          </span>
          <span className={Style.todo_sum_per_span} style={color_style_json.per}>
            {todo_info.percent}%
          </span>
        </div>
      );
    });
    return todo_detail_tags;
  };

  const get_subject_group_tags = (inData: any) => {
    let opt_obj = {
      subject_data_json: {},
      sort_title: "수업",
      ...inData
    };
    let subject_data_json = opt_obj.subject_data_json;
    let subject_data_arr: any = [];
    if (subject_data_json) {
      for (let key in subject_data_json) {
        subject_data_arr.push(subject_data_json[key]);
      }
    }

    let subject_group_tags = subject_data_arr.map((item: any, idx: number) => {
      let color_style_json = ColorFunc.get_color_style_of_percent(item.percent);
      let todo_detail_tags = get_todo_detail_tags(item.todo_info_arr);
      let row_title_str = item.subject + " " + opt_obj.sort_title;
      let row_file_cnt = item.file_cnt;
      if (row_file_cnt > 0) {
        row_title_str = row_title_str + " (" + row_file_cnt + ")";
      }
      return (
        <div key={idx}>
          <div className={Style.todo_sum_con_wrap} style={color_style_json.wrap}>
            <div className={Style.todo_sum_con_bar} style={color_style_json.bar}></div>
            <span className={Style.todo_sum_con_title} >
              <input type="text" value={row_title_str} readOnly style={{ background: "transparent", width: "65%", border: 0, cursor: "pointer" }} />
            </span>
            <span className={Style.todo_sum_per_span} style={color_style_json.per}>
              <span style={{ color: "#777" }}>{" (" + item.count + ")"}</span>
              <span className="ml-1">{item.percent}%</span>
            </span>
          </div>
          <div>
            {todo_detail_tags}
          </div>
        </div>
      );
    });
    return subject_group_tags;
  };

  const get_todo_sort_sum_tags = () => {
    let todo_sort_sum_tags = td_sort_data_arr.map((item: any, idx: number) => {
      let color_style_json = ColorFunc.get_color_style_of_percent(item.percent);
      //detail
      let todo_detail_tags = get_subject_group_tags({
        subject_data_json: item.subject_data_json,
        sort_title: item.title,
      });

      let row_file_cnt = item.file_cnt;
      let row_title_str = item.title;
      if (item.file_cnt > 0) {
        row_title_str = row_title_str + " (" + row_file_cnt + ")";
      }

      let is_empty_detail = false;
      if (strFunc.is_empty(todo_detail_tags)) {
        is_empty_detail = true;
        todo_detail_tags = (
          <div style={{ color: "#777", textAlign: "center", lineHeight: "20px", fontSize: "13px" }}>
            내용이 없습니다.
          </div>
        );
      }

      return (
        <div key={idx}>
          {is_empty_detail&&
            <div style={{ background: "#ddd",lineHeight:"22px" }}>
              {row_title_str}
            </div>
          }
          {todo_detail_tags}
        </div>
      );
    });

    return todo_sort_sum_tags;
  };

  return (
    <div className={Style.todo_sum_area}
      onClick={(e: any) => {
        myProps.openTodoDaySort({
          select_stu_name: myProps.select_stu_name,
          select_stu_seq: myProps.select_stu_seq,
          select_date: myProps.select_date,
        });
      }}
    >
      {/* {get_todo_sort_sum_tags()} */}
      <MidTodoArea
        info={{}}
        td_sort_data_arr={td_sort_data_arr}
        subject_name={""}
        base_date_str={myProps.select_date}
        pre_date_str={myProps.select_date}
        openTodoDaySort={myProps.openTodoDaySort}
      ></MidTodoArea>
    </div>
  );
};
export default TdTodoSumArea;